/* eslint-disable no-mixed-operators */

export default index => String.fromCharCode(65 + index % 26);
